import LocationIcon from '../../../assets/img/custom_field-location.svg';
import NumericalIcon from '../../../assets/img/custom_field-numerical.svg';
import PictureIcon from '../../../assets/img/custom_field-picture.svg';
import TextIcon from '../../../assets/img/custom_field-text.svg';

export type SectionsProjectFieldProps = {
  iconSrc: string;
  description?: string;
};

export type Sections = `vehicle` | `client` | `task`;

type VehicleSectionFields =
  | `external_id`
  | `plate`
  | `comments`
  | `email`
  | `phone`
  | `price_per_minute`
  | `price_per_distance`;

type ClientSectionFields =
  | `external_id`
  | `location_details`
  | `comments`
  | `email`
  | `reference_person`
  | `phone`
  | `url` /*| `optional`*/;

type TaskSectionFields = `barcode` | `comments`;

type SectionsProjectFieldsProps = {
  vehicle: Record<VehicleSectionFields, SectionsProjectFieldProps>;
  client: Record<ClientSectionFields, SectionsProjectFieldProps>;
  task: Record<TaskSectionFields, SectionsProjectFieldProps>;
};

export const getProjectFieldsBySection = (section: Sections) => {
  switch (section) {
    case `vehicle`:
      return [`external_id`, `plate`, `comments`, `email`, `phone`, `price_per_minute`, `price_per_distance`];
    case `client`:
      return [
        `external_id`,
        `location_details`,
        `comments`,
        `email`,
        `reference_person`,
        `phone`,
        `url`,
        // `optional`,
      ];
    case `task`:
      return [`barcode`, `comments`];
    default:
      return [];
  }
};

export const sectionsProjectFields: SectionsProjectFieldsProps = {
  vehicle: {
    external_id: {
      iconSrc: TextIcon,
    },
    plate: {
      iconSrc: TextIcon,
    },
    comments: {
      iconSrc: TextIcon,
    },
    email: {
      iconSrc: TextIcon,
    },
    phone: {
      iconSrc: TextIcon,
    },
    price_per_minute: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.vehicle.price_per_minute.description`,
    },
    price_per_distance: {
      iconSrc: NumericalIcon,
      description: `projects.settings.fields.vehicle.price_per_distance.description`,
    },
  },
  client: {
    external_id: {
      iconSrc: TextIcon,
    },
    location_details: {
      iconSrc: LocationIcon,
    },
    comments: {
      iconSrc: TextIcon,
    },
    email: {
      iconSrc: TextIcon,
    },
    reference_person: {
      iconSrc: TextIcon,
    },
    phone: {
      iconSrc: TextIcon,
    },
    url: {
      iconSrc: TextIcon,
    },
    // optional: {
    //   iconSrc: BooleanIcon,
    // },
  },
  task: {
    barcode: {
      iconSrc: PictureIcon,
    },
    comments: {
      iconSrc: TextIcon,
    },
  },
};
